import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type InvoiceResponse = ResponseType<string>;

function useGetInvoicePortalQuery() {
  return useQuery<
    AxiosResponseAndError<InvoiceResponse>["response"],
    AxiosResponseAndError<InvoiceResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.paymentInvoicePortal],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.paymentInvoicePortal),
    enabled: false,
  });
}

export default useGetInvoicePortalQuery;
